import { useEffect, useState } from "react";
import { api } from "./api";

// Module-level cache so every ArticleCard on a page shares one fetch
// (and a page-navigation doesn't refetch). Refreshes when the module is
// re-imported on a hard reload, which is exactly the granularity we want
// for a low-priority social-proof badge.
let _cache = null;
let _promise = null;

const fetchViews = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_promise) return _promise;
  _promise = api
    .get("/articles/views", { params: { days: 7, min_views: 3 } })
    .then((r) => {
      _cache = r.data || {};
      return _cache;
    })
    .catch(() => {
      _cache = {};
      return _cache;
    })
    .finally(() => {
      _promise = null;
    });
  return _promise;
};

export const useArticleViews = () => {
  const [views, setViews] = useState(_cache || {});
  useEffect(() => {
    if (_cache) return;
    let cancelled = false;
    fetchViews().then((v) => {
      if (!cancelled) setViews(v);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return views;
};
